import React, {useCallback} from 'react';
import clsx from 'clsx';
import {LightModeIcon} from '@ui/icons/material/LightMode';
import {DarkModeIcon} from '@ui/icons/material/DarkMode';
import {useThemeSelector} from '@ui/themes/theme-selector-context';
import {useTrans} from '@ui/i18n/use-trans';
import {message} from '@ui/i18n/message';

interface Props {
  className?: string;
  iconClassName?: string;
}

/**
 * Aydınlık/Karanlık tema toggle (güneş/ay). Tercih cookie'de saklanır
 * (theme-provider selectTheme → 365 gün). light = default; kullanıcı dark'a
 * geçebilir. Token tabanlı olmadığı için className ile her iki header
 * varyantına (koyu/şeffaf A + beyaz B) uyacak şekilde stillenebilir.
 */
export function DsThemeToggle({className, iconClassName}: Props) {
  const {selectedTheme, allThemes, selectTheme} = useThemeSelector();
  const {trans} = useTrans();
  const isDark = selectedTheme?.is_dark ?? false;

  const toggle = useCallback(() => {
    if (isDark) {
      const light =
        allThemes.find(t => t.default_light && !t.is_dark) ||
        allThemes.find(t => !t.is_dark);
      if (light) selectTheme(light.id);
    } else {
      const dark =
        allThemes.find(t => t.default_dark || t.is_dark) ||
        allThemes.find(t => t.is_dark);
      if (dark) selectTheme(dark.id);
    }
  }, [isDark, allThemes, selectTheme]);

  const label = trans(
    message(isDark ? 'Aydınlık moda geç' : 'Karanlık moda geç'),
  );

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      title={label}
      className={clsx(
        'inline-flex h-38 w-38 flex-shrink-0 items-center justify-center rounded-full transition-colors duration-200',
        className,
      )}
    >
      {isDark ? (
        <LightModeIcon size="sm" className={iconClassName} />
      ) : (
        <DarkModeIcon size="sm" className={iconClassName} />
      )}
    </button>
  );
}
